module.exports = __webpack_public_path__ + "fonts/Nunito-Regular.0c890be2.ttf";